import { useContext } from "react";

import SubscriptionFormContext from "./SubscriptionFormContext";

interface CartAPIFormProps {
  isSubscribing: boolean;
  sellingPlanId: string;
  isSubscribingToRefills: boolean;
  quantity: number;
}

export default function CartAPIForm({
  isSubscribing,
  sellingPlanId,
  isSubscribingToRefills,
  quantity,
}: CartAPIFormProps) {
  const {
    productIds: { baseProductId, refillProductId, fullApplicatorProductId },
  } = useContext(SubscriptionFormContext);
  return (
    <>
      {isSubscribing ? (
        <>
          <input
            type="hidden"
            name="id"
            value={
              isSubscribingToRefills ? refillProductId : fullApplicatorProductId
            }
          />
          <input type="hidden" name="selling_plan" value={sellingPlanId} />
        </>
      ) : (
        <input type="hidden" name="id" value={baseProductId} />
      )}
      <input type="hidden" name="quantity" value={quantity} />
    </>
  );
}
